// extracted by mini-css-extract-plugin
export default {"practice":"SplitPractice_practice__zM-0M","bar":"SplitPractice_bar__OdP6U","hint":"SplitPractice_hint__QB+QP","restart":"SplitPractice_restart__I4qw1"};